import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import DepartmentTopbar from "../SuperAdmin/components/DepartmentTopbar";
import DepartmentSidebar from "../SuperAdmin/components/DepertmentSidebar";

function AddAdvertisement() {
  const [formData, setFormData] = useState({
    agencyName: "",
    adSize: "",
    location: "",
    startDate: "",
    endDate: "",
    amount: "",
    agreementDocument: null,
    billNo: "",
  });

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, agreementDocument: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const apiPayload = new FormData();
    // Corrected keys to match the API
    apiPayload.append("agency", formData.agencyName);
    apiPayload.append("ad_size", formData.adSize);
    apiPayload.append("location", formData.location);
    apiPayload.append("start_date", formData.startDate);
    apiPayload.append("end_date", formData.endDate);
    apiPayload.append("amount", formData.amount);
    apiPayload.append("bill_no", formData.billNo);
    if (formData.agreementDocument) {
      apiPayload.append("agreement_doc", formData.agreementDocument);
    }

    try {
      const response = await axios.post(
        `${API_URL}add-advertisement.php`,
        apiPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status) {
        toast.success(
          response.data.message || "Advertisement saved successfully!"
        );
        // Reset form after successful submission
        setFormData({
          agencyName: "",
          adSize: "",
          location: "",
          startDate: "",
          endDate: "",
          amount: "",
          agreementDocument: null,
          billNo: "",
        });
        e.target.reset(); // This helps clear the file input field
      } else {
        toast.error(response.data.message || "Failed to save advertisement.");
      }
    } catch (error) {
      toast.error("An error occurred while saving the advertisement.");
    }
  };

  return (
    <>
      <DepartmentTopbar />
      <div className="d-flex">
        <DepartmentSidebar />
        <Container fluid className="p-4 bg-light">
          <h2 className="mb-4">Add New Advertisement</h2>
          <Row>
            <Col>
              <Card className="shadow-sm">
                <Card.Header
                  as="h5"
                  style={{
                    backgroundColor: "#e3f2fd",
                    borderBottom: "2px solid #1976d2",
                  }}
                >
                  <span style={{ color: "#1976d2" }}>
                    New Advertisement Form
                  </span>
                </Card.Header>
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6" controlId="agencyName">
                        <Form.Label>Agency Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="agencyName"
                          value={formData.agencyName}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                      <Form.Group as={Col} md="6" controlId="adSize">
                        <Form.Label>Ad Size (e.g., 10x20 ft)</Form.Label>
                        <Form.Control
                          type="text"
                          name="adSize"
                          value={formData.adSize}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Row>
                    <Form.Group className="mb-3" controlId="location">
                      <Form.Label>Location</Form.Label>
                      <Form.Control
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6" controlId="startDate">
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="startDate"
                          value={formData.startDate}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                      <Form.Group as={Col} md="6" controlId="endDate">
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="endDate"
                          value={formData.endDate}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6" controlId="amount">
                        <Form.Label>Amount (₹)</Form.Label>
                        <Form.Control
                          type="number"
                          name="amount"
                          value={formData.amount}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                      <Form.Group as={Col} md="6" controlId="billNo">
                        <Form.Label>Bill No</Form.Label>
                        <Form.Control
                          type="text"
                          name="billNo"
                          value={formData.billNo}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Row>
                    <Form.Group controlId="agreementDocument" className="mb-3">
                      <Form.Label>Agreement Document</Form.Label>
                      <Form.Control
                        type="file"
                        name="agreementDocument"
                        onChange={handleFileChange}
                      />
                    </Form.Group>
                    <Button variant="primary" type="submit" className="mt-2">
                      Save Advertisement
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default AddAdvertisement;
